enum MedfarDictionariesValidationRuleTypeEnum {
    PhoneNumber = 1,
    HealthIdentification,
    PostalCode,
    SocialSecurityNumber,
    PaymentCard
}

export { MedfarDictionariesValidationRuleTypeEnum };
